// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"3ec649cf","568":"af22d19d"}[chunkId] + ".chunk.css";
};